var _circle, _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuicktbreadrans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#00adef"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_593_444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 18H18V42H42V18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_593_444)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_593_444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18H18V42H42V18Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_593_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4883 38.875C39.713 38.875 39.082 39.506 39.082 40.2813C39.082 41.0565 39.713 41.6875 40.4883 41.6875C41.2636 41.6875 41.8945 41.0565 41.8945 40.2813C41.8945 39.506 41.2636 38.875 40.4883 38.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4883 29.0312C39.713 29.0312 39.082 29.6622 39.082 30.4375C39.082 31.2128 39.713 31.8437 40.4883 31.8437C41.2636 31.8437 41.8945 31.2128 41.8945 30.4375C41.8945 29.6622 41.2636 29.0312 40.4883 29.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7061 30.4375C20.7061 31.2128 21.337 31.8437 22.1123 31.8437C22.8876 31.8437 23.5186 31.2128 23.5186 30.4375C23.5186 29.6622 22.8876 29.0312 22.1123 29.0312C21.337 29.0312 20.7061 29.6622 20.7061 30.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5186 40.2813C23.5186 39.506 22.8876 38.875 22.1123 38.875C21.337 38.875 20.7061 39.506 20.7061 40.2813C20.7061 41.0565 21.337 41.6875 22.1123 41.6875C22.8876 41.6875 23.5186 41.0565 23.5186 40.2813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6748 30.4375C37.6748 29.923 37.8237 29.4465 38.0659 29.0312H24.5337C24.776 29.4465 24.9248 29.923 24.9248 30.4375C24.9248 31.9886 23.6634 33.25 22.1123 33.25C21.5978 33.25 21.1213 33.1011 20.7061 32.8589V37.8598C21.1213 37.6176 21.5978 37.4687 22.1123 37.4687C23.6634 37.4687 24.9248 38.7302 24.9248 40.2813C24.9248 40.7958 24.776 41.2722 24.5337 41.6875H38.0659C37.8237 41.2722 37.6748 40.7958 37.6748 40.2813C37.6748 38.7302 38.9362 37.4687 40.4873 37.4687C41.0019 37.4687 41.4783 37.6176 41.8935 37.8598V32.8589C41.4783 33.1011 41.0019 33.25 40.4873 33.25C38.9362 33.25 37.6748 31.9886 37.6748 30.4375ZM31.2529 34.6562C32.416 34.6562 33.3623 35.6025 33.3623 36.7656C33.3623 37.6811 32.7727 38.4542 31.9561 38.7455V39.5781C31.9561 39.9667 31.6415 40.2813 31.2529 40.2813C30.8644 40.2813 30.5498 39.9667 30.5498 39.5781V38.7455C29.7332 38.4542 29.1435 37.6811 29.1435 36.7656C29.1435 36.3771 29.4581 36.0625 29.8467 36.0625C30.2353 36.0625 30.5498 36.3771 30.5498 36.7656C30.5498 37.1536 30.8649 37.4687 31.2529 37.4687C31.6409 37.4687 31.9561 37.1536 31.9561 36.7656C31.9561 36.3776 31.6409 36.0625 31.2529 36.0625C30.0899 36.0625 29.1435 35.1162 29.1435 33.9531C29.1435 33.0376 29.7332 32.2645 30.5498 31.9732V31.1406C30.5498 30.752 30.8644 30.4375 31.2529 30.4375C31.6415 30.4375 31.9561 30.752 31.9561 31.1406V31.9732C32.7727 32.2645 33.3623 33.0376 33.3623 33.9531C33.3623 34.3416 33.0477 34.6562 32.6592 34.6562C32.2706 34.6562 31.9561 34.3416 31.9561 33.9531C31.9561 33.5651 31.6409 33.25 31.2529 33.25C30.8649 33.25 30.5498 33.5651 30.5498 33.9531C30.5498 34.3411 30.8649 34.6562 31.2529 34.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5972 20.5937H29.8471C30.2355 20.5937 30.5503 20.279 30.5503 19.8906V18.3906C30.5503 18.0023 30.2355 17.6875 29.8471 17.6875H18.5972C18.2088 17.6875 17.894 18.0023 17.894 18.3906V19.8906C17.894 20.279 18.2088 20.5937 18.5972 20.5937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0029 22C19.6146 22 19.2998 22.3147 19.2998 22.7031V24.1093C19.2998 24.4977 19.6146 24.8125 20.0029 24.8125H31.2529C31.6413 24.8125 31.9561 24.4977 31.9561 24.1093V22.7031C31.9561 22.3147 31.6413 22 31.2529 22H20.0029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5972 36.0625H19.3003V31.8438H17.894V35.3593C17.894 35.753 18.2033 36.0625 18.5972 36.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3003 29.7344C19.3003 28.5671 20.2423 27.625 21.4096 27.625H30.5503V26.9219C30.5503 26.528 30.241 26.2188 29.8471 26.2188H18.5972C18.2033 26.2188 17.894 26.528 17.894 26.9219V30.4375H19.3003V29.7344Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicktbreadrans);
export default __webpack_public_path__ + "static/media/quicktbreadrans.d389505ad09068bd65f2062d20b6932b.svg";
export { ForwardRef as ReactComponent };